import { useMemo } from "react";
import { Attribute } from "../interfaces/Attribute";

/**
 * Hook which finds and returns a memoized attribute value for the given key from an array of attributes
 * @param attributes - An array of attributes
 * @param key - The attribute key
 * @returns The attribute value string. Returns undefined if attribute not found.
 */
export function useAttributeValueByKey(attributes: Attribute[] | undefined, key: string) {
  return useMemo(() => {
    return getAttributeValueByKey(attributes, key);
  }, [attributes, key]);
}

/**
 * Function which finds and returns an attribute value for the given key from an array of attributes
 * @param attributes - An array of attributes
 * @param key - The attribute key
 * @returns The attribute value string. Returns undefined if attribute not found.
 */
export function getAttributeValueByKey(attributes: Attribute[] | undefined, attributeKey: string) {
  return attributes?.find((attribute) => attribute.key === attributeKey)?.value;
}
